<template lang="pug">
div(v-if="standort")
  v-card.mb-3
    v-card-title.title.grey.lighten-3 Aussenstelle {{standort.aussenstelle}}
    v-card-text
      div(v-if="standort.strasse") {{standort.strasse}} {{standort.hausnummer}}
      div(v-if="standort.plz || standort.ort") {{standort.plz}} {{standort.ort}}
      div(v-if="standort.ip") Netz: {{standort.ip}}
      div(v-if="standort.bandbreiteAktuell") Bandbreite (Aktuell): {{standort.bandbreiteAktuell}}
      div(v-if="standort.bandbreiteMax") Bandbreite (Max): {{standort.bandbreiteMax}}

      .title.my-1 Dienstleister
      template(v-for="anbieter in standort.itAnbieter || []")
        .d-flexx.align-end
          div
            span.subheading {{anbieter.name}}
            span(v-if="anbieter.art")  ({{anbieter.art.name}})
          v-spacer
          div: v-img(:src="anbieter.logo" v-if="anbieter.logo" width="100" height="35" position="center right" contain)
        div(v-if="anbieter.telefon") Tel.: {{anbieter.telefon}}

  v-card.mb-3(v-for="projekt in standort.projekte" :key="projekt.id")
    v-card-title.title.grey.lighten-3
      a(:href="`/p/${projekt.pnr}`") {{projekt.name}}
      v-spacer
      div: v-img(:src="projekt.logo" v-if="projekt.logo" width="100" height="35" position="center right" contain)
    v-card-text
      div(v-if="projekt.telefon") Tel.: {{projekt.telefon}}
      div(v-if="projekt.email") E-Mail: {{projekt.email}}

      div Mitarbeiter {{personenProProjekt[projekt.id] || 0}}

      .title.my-1 Dienstleister
      .d-flexx.align-end(v-if="projekt.anbieter")
        div
          span.subheading {{projekt.anbieter.name}}
          span(v-if="projekt.anbieter.art")  ({{projekt.anbieter.art.name}})
        v-spacer
        div: v-img(:src="projekt.anbieter.logo" v-if="projekt.anbieter.logo" width="100" height="35" position="center right" contain)
      div(v-if="projekt.anbieter && projekt.anbieter.telefon") Tel.: {{projekt.anbieter.telefon}}

</template>

<script>
import gql from 'graphql-tag'
import GraphqlErrorObject from '../../mixins/graphql-error-object.js'
import MeinProjekt from '../mein-projekt'
import { user } from '../../router'

export default {
  props: ['extra'],
  mixins: [GraphqlErrorObject],
  components: {
    MeinProjekt
  },
  data() {
    return {
      user: user,
      itTickets: [],
      status: null,
      ticket: null,
      person: null,
      statusOptions: [
        { text: 'Neu', value: 'neu' },
        { text: 'In Bearbeitung', value: 'in_bearbeitung' },
        { text: 'Erledigt', value: 'erledigt' },
        { text: 'Geschlossen', value: 'geschlossen' }
      ]
    }
  },
  apollo: {
    standorte: {
      query: gql`query ExtraAsDetailsVueStandorte($as: String) {
        standorte(as: $as) {
          id
          aussenstelle
          name
          strasse
          hausnummer
          plz
          ort
          bandbreiteMax
          bandbreiteAktuell
          ip
          itAnbieter {
            id
            name
            telefon
            logo(size: "x35")
            art {
              id
              name
            }
          }
          projekte {
            id
            pnr
            name
            telefon
            email
            logo(size: "x35")
            anbieter {
              id
              name
              telefon
              logo(size: "x35")
              art {
                id
                name
              }
            }
          }
        }
      }`,
      skip() {
        return !this.isAuthorized || !this.$route.params.slug
      },
      variables() {
        return {
          as: this.$route.params.slug,
        }
      },
    },
    personen: {
      query: gql`query ExtraAsDetailsVuePersonen($q: String) {
        personen(q: $q, where: { art: "mitarbeiter", status: "angestellt" }) {
          id
          projekte {
            id
          }
        }
      }`,
      variables() {
        return {
          q: JSON.stringify({ projekte_standort_id_eq: this.standort.id })
        }
      },
      skip() {
        return !this.isAuthorized || !this.standort || !this.standort.id
      }
    },
  },
  computed: {
    isAuthorized() {
      const user = this.user
      if (user && user.person && user.person.vorstand || user.person.bereichsleitung || user.person.abteilungsleitung || user.person.ticketBearbeiter) {
        return true
      } else {
        return false
      }
    },
    standort() {
      return this.standorte && this.standorte[0]
    },
    personenProProjekt() {
      const projekte = {}
      this.personen && this.personen.forEach((person) => {
        person.projekte.forEach((projekt) => {
          projekte[projekt.id] = (projekte[projekt.id] || 0) + 1
        })
      })
      return projekte
    }
  }
}
</script>
